import { get as _get } from 'lodash';
import createReducer from '../createReducer';
import {
  ContextRouterAction,
  ContextRouterActions,
  ContextRouterState,
  initialContextRouterState,
} from './ContextRouterState.model';

export const contextRouterReducer = createReducer<ContextRouterState>(initialContextRouterState, {
  [ContextRouterActions.VALIDATE_CONTEXT_ROUTER](state: ContextRouterState, action: ContextRouterAction) {
    return {
      ...state,
      urlKey: action.payload.urlKey,
      authKey: action.payload.authKey,
      loading: true,
      loaded: false,
      hasError: false,
    };
  },
  [ContextRouterActions.VALIDATE_CONTEXT_ROUTER_SUCCESS](state: ContextRouterState, action: ContextRouterAction) {
    const updatedAuthKey = _get(action, 'payload.updatedAuthToken', state.authKey);
    const sessionId = _get(action, 'payload.afeSessionId', state.sessionId);
    return {
      ...state,
      authKey: updatedAuthKey,
      sessionId: sessionId,
      loading: false,
      loaded: true,
      hasError: false,
      blobResponse: _get(action, 'payload'),
    };
  },
  [ContextRouterActions.VALIDATE_CONTEXT_ROUTER_FAIL](state: ContextRouterState, action: ContextRouterAction) {
    return { ...state, loading: false, loaded: true, hasError: true };
  },
  [ContextRouterActions.UPDATE_CONTEXT_ROUTER_AUTHKEY](state: ContextRouterState, action: ContextRouterAction) {
    const updatedAuthKey = _get(action, 'payload', state.authKey);
    return {
      ...state,
      authKey: updatedAuthKey,
      loading: false,
      loaded: true,
      hasError: false,
    };
  },
  [ContextRouterActions.SET_OPCO_THEME](state: ContextRouterState, action: ContextRouterAction) {
    const updatedOpCoTheme = _get(action, 'payload', '');
    return {
      ...state,
      opcoTheme: updatedOpCoTheme,
    };
  },
});
